export const ListingViewConstants = {
    CardView:"Card View",
    ListView:"List View"
};

export const ActivityBulkActions = {
    Accept: 0,
    Reject: 1,
    AcceptReassign: 2
}